import React, { useState, type FC } from "react";
import { ClientId } from "~/typings/types";
import { AutofillFieldButton, ErrorField, MobileTooltip } from "~/components";
import { AutocompleteInput } from "./AutocompleteInput";

import styles from "./Autocomplete.module.scss";
import { AnimatedContainer } from "~/containers";


export type GetErrorSuggestions = {
  code: string;
  message: string;
} | null

interface Props {
  name: string;
  nameFiasId: string;
  clientId: ClientId;
  titleField?: string;
  validate?: any;
  required?: boolean;
  tooltip?: string;
  isColon?: boolean;
  styleContainerTitleField?: any;
  styleContainer?: any;
  placeholder?: string;
  children?: React.ReactNode;
  disabled?: boolean;
  renderError?: any;
  triggerAutofill?: string[];
  triggerAutofillForAddressFiasId?: string[];
  propsSpy: any;
  urlPersonalDataAddressSuggest: string;
  triggerAutofillTextButton?: string;
  onSuggestionPicked?: (suggestion: any, form: any) => void;
  onClearSuggestionPickedState?: (form: any) => void;
}

export const FormFieldAutocompleteAddress: FC<Props> = ({
  name,
  nameFiasId,
  styleContainer,
  renderError,
  triggerAutofill,
  triggerAutofillForAddressFiasId,
  triggerAutofillTextButton,
  ...propsAutocompleteInput
}) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [errorGetSuggestions, setErrorGetSuggestions] = useState<GetErrorSuggestions>(null);
  const customErrorField =
    renderError || (errorGetSuggestions && { has: 1, message: errorGetSuggestions.message });

  const errors = propsAutocompleteInput.propsSpy.errors;
  const nameErrorField =
    errors && errors?.[name] === "Обязательно для заполнения" ? name : nameFiasId;

  return (
    <div className={styles.containerField} style={styleContainer}>
      <div className={styles.containerInput}>
        <AutocompleteInput
          {...propsAutocompleteInput}
          name={name}
          nameFiasId={nameFiasId}
          propsSpy={propsAutocompleteInput.propsSpy}
          setErrorGetSuggestions={setErrorGetSuggestions}
          customError={!!customErrorField}
          setIsTooltipVisible={setIsTooltipVisible}
        />
      </div>

      <AnimatedContainer isVisible={isTooltipVisible}>
        <MobileTooltip content={propsAutocompleteInput.tooltip} />
        <AutofillFieldButton
          triggerAutofill={triggerAutofill}
          triggerAutofillForAddressFiasId={triggerAutofillForAddressFiasId}
          textButton={triggerAutofillTextButton}
        />
      </AnimatedContainer>
     
      <ErrorField name={nameErrorField} renderError={customErrorField} />
    </div>
  );
};